module.exports = __webpack_public_path__ + "src/assets/img/viscom.b658ad05.jpg";